import { render, staticRenderFns } from "./EstadisticasCompras.vue?vue&type=template&id=37b064f2&scoped=true&lang=pug"
import script from "./EstadisticasCompras.vue?vue&type=script&lang=js"
export * from "./EstadisticasCompras.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCompras.vue?vue&type=style&index=0&id=37b064f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b064f2",
  null
  
)

export default component.exports